import React from 'react'
import {
    useMantineTheme,
    BackgroundImage,
    Box,
    Container,
    Divider,
    Grid,
    Stack,
    Text,
    Space,
} from '@mantine/core'
import parse from 'html-react-parser'
import HeaderMain from 'components/UI/Headers/HeaderMain/HeaderMain'
import NavigationMain from 'components/UI/NavigationMain/NavigationMain'
import FooterMain from 'components/UI/FooterMain/FooterMain'
import HeaderPage from 'components/UI/Headers/HeaderPage/HeaderPage'
import BreadcrumbsMain from 'components/UI/Breadcrums/BreadcrumsMain/BreadcrumsMain'
import useScreen from 'hooks/useScreen'
import styles from './styles.module.scss'
import PageLoader from 'components/UI/PageLoader/PageLoader'
import HoverCard from 'components/UI/Cards/HoverCard/HoverCard'
import CardsContainer from 'components/UI/Containers/CardsContainer/CardsContainer'
import StoryCard from 'components/UI/Cards/StoryCard/StoryCard'

const Wellness = () => {
    const theme = useMantineTheme()
    const { instance, themes, pageData } = useScreen()

    if (!pageData) {
        return <PageLoader />
    } else {
        const { data, referencedPosts } = pageData
        return (
            <div className={styles.container}>
                <div className={styles.layout}>
                    <HeaderMain />
                    <NavigationMain />
                    <main>
                        <HeaderPage
                            title={data.title}
                            summary={data.summary}
                            theme='themeAmber'
                        />
                        <BreadcrumbsMain pageData={pageData} />
                        {data.media.heroImage.src && (
                            <Container size='1280px' py='2x'>
                                <BackgroundImage
                                    src={data.media.heroImage.src}
                                    sx={{
                                        aspectRatio: '4/1',
                                    }}
                                />
                            </Container>
                        )}
                        {pageData?.posts.length > 0 && (
                            <Container size='1280px' py='2x' px={0}>
                                <Stack spacing='xl'>
                                    {pageData.posts.map((post, index) => {
                                        const contentType =
                                            post.config.contentType
                                        const contentData = post.data
                                        const contentPosts = post.posts
                                        switch (contentType) {
                                            case '683e494dec35bf3a3c82cae3':
                                                return (
                                                    <Box key={post._id}>
                                                        {contentData.title && (
                                                            <Text
                                                                component='div'
                                                                fw='bold'
                                                                fz='lg'
                                                                color='var(--mantine-color-purple-0)'
                                                            >
                                                                {
                                                                    contentData.title
                                                                }
                                                            </Text>
                                                        )}
                                                        {contentData.description && (
                                                            <Text component='div'>
                                                                {parse(
                                                                    contentData.description
                                                                )}
                                                            </Text>
                                                        )}
                                                    </Box>
                                                )
                                            case '683e5692ec35bf3a3c82cae5':
                                                return (
                                                    <Box key={post._id}>
                                                        <Grid
                                                            gutter='8rem'
                                                            justify='center'
                                                        >
                                                            {contentPosts.map(
                                                                (postChild) => (
                                                                    <Grid.Col
                                                                        key={
                                                                            postChild._id
                                                                        }
                                                                        span={3}
                                                                    >
                                                                        <HoverCard
                                                                            {...postChild.data}
                                                                        />
                                                                    </Grid.Col>
                                                                )
                                                            )}
                                                        </Grid>
                                                    </Box>
                                                )
                                            case '654253ecda7c0026a241618f':
                                                return (
                                                    <Box key={post._id}>
                                                        {contentPosts.map(
                                                            (post) => (
                                                                <div>
                                                                    {
                                                                        post
                                                                            .data
                                                                            .title
                                                                    }
                                                                </div>
                                                            )
                                                        )}
                                                    </Box>
                                                )

                                            case '6847afbd2456c109e8beed87':
                                                return (
                                                    <Divider
                                                        h={4}
                                                        key={post._id}
                                                    />
                                                )

                                            default:
                                                return null
                                        }
                                    })}
                                </Stack>
                            </Container>
                        )}
                        <Container size='1280px' px={0}>
                            <Divider />
                        </Container>
                        <Space h='2x' />
                        {referencedPosts[0].items.length > 0 && (
                            <CardsContainer
                                aspectRatio='3/2'
                                cols={3}
                                component={<StoryCard />}
                                items={referencedPosts[0].items}
                            />
                        )}
                        <Space h='2x' />
                    </main>
                    <FooterMain />
                </div>
            </div>
        )
    }
}

export default Wellness
